import { useMemo } from 'react';
import type { FieldValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { resolveLocale } from '@/i18n';
import { countryOptions } from '@/lib/countries';

import { FormSelectField } from './FormSelectField';
import type { FieldBaseProps } from './types';

type Props<T extends FieldValues> = FieldBaseProps<T> & {
  placeholder?: string;
};

export function FormCountryField<T extends FieldValues>(props: Props<T>) {
  const { i18n } = useTranslation();
  const locale = resolveLocale(i18n.language);
  const options = useMemo(() => countryOptions(locale), [locale]);
  return <FormSelectField {...props} options={options} />;
}
